import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    searchOnMap: translate({ id: 'map.controls.searchOnMap' }),
  }))

  return api
}
